import React from 'react';
import PropTypes from 'prop-types';

import { Col, Form, Row } from 'react-bootstrap';
import Select from 'react-select/creatable';

import { blackberry, white } from 'lib/css/colors';
import {
  CEILING_LIMIT,
  FLOOR_LIMIT,
  paymentTypeLimits,
  paymentTypeOptions,
  paymentTypes,
} from 'lib/enums/PaymentInfoEnums';

function PaymentInfoSection({ payRateInfo, setPayRateInfo }) {
  const handlePaymentTypeChange = value => {
    if (value === paymentTypes.HOURLY) {
      setPayRateInfo({
        rate: {
          ceiling: { amount: '' },
        },
        payment_type: value,
      });
    } else if (value === paymentTypes.MONTHLY) {
      setPayRateInfo({
        rate: {
          ceiling: { amount: '' },
        },
        payment_type: value,
      });
    } else if (value === paymentTypes.TIER) {
      setPayRateInfo({
        rate: {
          floor: { amount: '', hours: FLOOR_LIMIT },
          ceiling: { amount: '', hours: CEILING_LIMIT },
          between: { amount: '' },
        },
        payment_type: value,
      });
    } else {
      setPayRateInfo({
        rate: {
          floor: { hours: '', amount: '' },
          ceiling: { hours: '', amount: '' },
          between: { amount: '' },
        },
        payment_type: '',
      });
    }
  };

  const handlePayRateChange = (value, paymentType, field = null) => {
    if (paymentType === paymentTypes.HOURLY) {
      setPayRateInfo({
        rate: {
          ceiling: {
            amount: value,
          },
        },
        payment_type: paymentTypes.HOURLY,
      });
    } else if (paymentType === paymentTypes.MONTHLY) {
      setPayRateInfo({
        rate: {
          ceiling: {
            amount: value,
          },
        },
        payment_type: paymentTypes.MONTHLY,
      });
    } else if (paymentType === paymentTypes.TIER) {
      if (field === paymentTypeLimits.FLOOR) {
        setPayRateInfo({
          payment_type: paymentTypes.TIER,
          rate: {
            ...payRateInfo.rate,
            floor: {
              hours: FLOOR_LIMIT,
              amount: value,
            },
          },
        });
      } else if (field === paymentTypeLimits.BETWEEN) {
        setPayRateInfo({
          payment_type: paymentTypes.TIER,
          rate: {
            ...payRateInfo.rate,
            between: {
              amount: value,
            },
          },
        });
      } else if (field === paymentTypeLimits.CEILING) {
        setPayRateInfo({
          payment_type: paymentTypes.TIER,
          rate: {
            ...payRateInfo.rate,
            ceiling: {
              hours: CEILING_LIMIT,
              amount: value,
            },
          },
        });
      }
    }
  };

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? blackberry : white,
      '&:hover': {
        backgroundColor: white,
        color: white,
      },
    }),
  };

  return (
    <>
      <Form.Group>
        <Form.Label>Payment Type</Form.Label>
        <Select
          styles={customStyles}
          classNamePrefix="themed_select"
          value={paymentTypeOptions.find(option => option.value === payRateInfo.payment_type)}
          onChange={option => handlePaymentTypeChange(option?.value || null)}
          options={paymentTypeOptions}
          isClearable={true}
        />
      </Form.Group>
      {payRateInfo.payment_type === paymentTypes.MONTHLY && (
        <Form.Group>
          <Form.Label>Monthly Pay Rate</Form.Label>
          <Form.Control
            value={payRateInfo.rate.ceiling.amount}
            onChange={e => handlePayRateChange(e.target.value, paymentTypes.MONTHLY, null)}
            type="text"
          />
        </Form.Group>
      )}
      {payRateInfo.payment_type === paymentTypes.HOURLY && (
        <Form.Group>
          <Form.Label>Hourly Pay Rate</Form.Label>
          <Form.Control
            value={payRateInfo.rate.ceiling.amount}
            onChange={e => handlePayRateChange(e.target.value, paymentTypes.HOURLY, null)}
            type="text"
          />
        </Form.Group>
      )}
      {payRateInfo.payment_type === paymentTypes.TIER && (
        <>
          <Row>
            <Col>
              <Form.Label>{`< ${payRateInfo.rate.floor.hours} hours`}</Form.Label>
              <Form.Control
                value={payRateInfo.rate.floor.amount}
                onChange={e =>
                  handlePayRateChange(e.target.value, paymentTypes.TIER, paymentTypeLimits.FLOOR)
                }
                type="text"
              />
            </Col>
            <Col>
              <Form.Label>
                {`${payRateInfo.rate.floor.hours} - ${payRateInfo.rate.ceiling.hours} hours`}
              </Form.Label>
              <Form.Control
                value={payRateInfo.rate.between.amount}
                onChange={e =>
                  handlePayRateChange(e.target.value, paymentTypes.TIER, paymentTypeLimits.BETWEEN)
                }
                type="text"
              />
            </Col>
            <Col>
              <Form.Label>{`> ${payRateInfo.rate.ceiling.hours} hours`}</Form.Label>
              <Form.Control
                value={payRateInfo.rate.ceiling.amount}
                onChange={e =>
                  handlePayRateChange(e.target.value, paymentTypes.TIER, paymentTypeLimits.CEILING)
                }
                type="text"
              />
            </Col>
          </Row>
        </>
      )}
    </>
  );
}

PaymentInfoSection.propTypes = {
  payRateInfo: PropTypes.object,
  setPayRateInfo: PropTypes.func,
};

export default PaymentInfoSection;
